import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left text-textPrimary" }
const _hoisted_2 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_3 = { class: "flex items-center bg-gray-50 rounded-lg border border-gray-100 p-1 pr-3 shadow-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-[10px] text-gray-400 uppercase font-bold leading-none" }, "Estação", -1)
const _hoisted_5 = { class: "text-sm font-medium text-gray-500 leading-tight" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-gray-400 mx-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-base md:text-xl font-bold text-gray-700 leading-tight" }
const _hoisted_9 = { class: "font-bold text-lg md:text-2xl" }
const _hoisted_10 = { class: "text-xs md:text-base text-primary40 flex items-center gap-1 flex-wrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 text-xs mx-1" }, "›", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 text-xs mx-1" }, "›", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 text-xs mx-1" }, "›", -1)

import { PropType, computed } from 'vue'
import { ShiftDetails } from '@/Network/Types/Responses/StationResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionModalHeader',
  props: {
  stationDetails: {
    type: Object as PropType<ShiftDetails | null>,
    default: () => null
  },
  title: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



// Helper para verificar se existe o ID do vínculo médico
const hasDoctorStation = computed(() => {
  return !!props.stationDetails?.doctorStation?.id
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col px-2", { 'border-r border-gray-200 mr-2': hasDoctorStation.value }])
        }, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(__props.stationDetails?.id), 1)
        ], 2),
        (hasDoctorStation.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(__props.stationDetails?.doctorStation?.id), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("span", _hoisted_10, [
      _createTextVNode(_toDisplayString(__props.stationDetails?.schedule?.healthUnit?.company?.name || 'Company') + " ", 1),
      _hoisted_11,
      _createTextVNode(" " + _toDisplayString(__props.stationDetails?.schedule?.healthUnit?.name || 'Health Unit') + " ", 1),
      _hoisted_12,
      _createTextVNode(" " + _toDisplayString(__props.stationDetails?.schedule?.name || 'Schedule') + " ", 1),
      _hoisted_13,
      _createTextVNode(" " + _toDisplayString(__props.stationDetails?.position?.name || 'Position not defined'), 1)
    ])
  ]))
}
}

})